<p-table [value]="users?.content" [paginator]="true" [lazy]="true" [loading]="!users?.content"
    paginatorPosition="bottom" (onLazyLoad)="onPageChange($event)" [totalRecords]="users?.totalElements"
    [rows]="pageSize" class="admin-table users-table">

    <ng-template pTemplate="emptymessage" let-columns>
        <div>{{ 'WS_DIRECTORY.TABLE_EMPTY' | translate }}</div>
    </ng-template>
    <ng-template pTemplate="header">
        <tr>
            <th width="18%">{{ 'USER_REPORTS.ROLE_COUNT_TAB.TABLE.TABLE_HEADER_NAME' | translate }}</th>
            <th width="20%">{{ 'USER_REPORTS.ROLE_COUNT_TAB.TABLE.TABLE_HEADER_EMAIL' | translate }}</th>
            <th width="21%">{{ 'USER_REPORTS.ROLE_COUNT_TAB.TABLE.TABLE_HEADER_ROLES' | translate }}</th>
            <th width="14%">{{ 'USER_REPORTS.ROLE_COUNT_TAB.TABLE.TABLE_HEADER_ORGANIZATION' | translate }}</th>
            <th width="10%">{{ 'USER_REPORTS.ROLE_COUNT_TAB.TABLE.TABLE_HEADER_COUNTRY' | translate }}</th>
            <th width="12%">{{ 'USER_REPORTS.ROLE_COUNT_TAB.TABLE.TABLE_HEADER_REGION' | translate }}</th>
            <th width="5%"></th>
        </tr>
    </ng-template>
    <ng-template let-user pTemplate="body">
        <tr>
            <td>
                {{user.name}}
            </td>
            <td>
                {{user.email }}
            </td>
            <td>
                <p *ngFor="let _s of separateRoles(user.roles)">{{ _s }}</p>
            </td>
            <td>
                {{ user.organization}}
            </td>
            <td>
                {{ user.country}}
            </td>
            <td>
                {{ user.region}}
            </td>
            <td class="action-column">
                <i class="fa fa-pen edit-appointment fright" (click)="modifyUser(user)"
                    pTooltip="{{ 'USER_REPORTS.ROLE_COUNT_TAB.TABLE.MODIFY_TOOLTIP' | translate }}"></i>
            </td>
        </tr>
    </ng-template>
</p-table>